import { ShopProduct } from '@/models/order';
import { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';
import { StarjackTable } from '@/components/Table/v2/Table';
import { getMoneyAsString } from '@/utils';
import { usePagination } from '@starjack/shared-components';

type OrderDetailsShopProductsTableProps = {
    shopProducts: ShopProduct[];
};

export const OrderDetailsShopProductsTable: FunctionComponent<
    OrderDetailsShopProductsTableProps
> = ({ shopProducts = [] }) => {
    const {
        currentItems: currentShopProducts,
        itemsPerPage: shopProductsPerPage,
        setNextPage: setShopProductsPage,
        setItemsPerPage,
        countTotal,
        page,
    } = usePagination({
        items: shopProducts,
        itemsPerPage: 10,
    });

    return (
        <Box>
            <Typography
                sx={{
                    mb: 4,
                }}
                variant='h5'
            >
                Shop Produkte
            </Typography>

            <StarjackTable<ShopProduct>
                count={countTotal}
                allItems={shopProducts}
                items={currentShopProducts}
                currentPage={page}
                onPageChange={setShopProductsPage}
                rowsPerPage={shopProductsPerPage}
                onRowsPerPageChange={setItemsPerPage}
                itemId='id'
                columns={[
                    {
                        label: 'Interne Id',
                        itemKey: 'id',
                    },
                    {
                        label: 'Name',
                        itemTransform: (product) => product.name.de,
                    },
                    {
                        label: 'Preis',
                        itemTransform: (product) =>
                            getMoneyAsString(product.price),
                    },
                    {
                        label: 'Voucher',
                        itemTransform: (product) =>
                            product.voucher ? 'Ja' : 'Nein',
                    },
                ]}
            />
        </Box>
    );
};
